import React from 'react';
import * as Sentry from '@sentry/react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { SentryRoutes } from '../common/sentry';
import CompleteTimesheet from './pages/CompleteTimesheet';
import Dashboard from './pages/Dashboard';
import RemoteWorkingForm from './pages/RemoteWorkingForm';
import FeedbackTopicPage from './pages/FeedbackTopicPage';
import RecruitmentCandidates from './pages/RecruitmentCandidates';
import CandidatesAdminList from './pages/CandidatesAdminList';
import RolePage from './pages/Role';
import TeamTime from './pages/TeamTime';
import UserProfilePage from './pages/UserProfilePage';
import UserChecklist from './pages/UserChecklist';
import UsersPage from './pages/UsersPage';
import NewStartersPage from './pages/NewStartersPage';
import ShoutoutsPage from './pages/ShoutoutsPage';
import HealthAndSafetyPage from './pages/HealthAndSafetyPage';
import PeopleLayout, { BasicPeopleLayout } from './layout/PeopleLayout';
import Skills from './pages/Skills';
import ProgressionPage from './pages/Progression';
import Jobs from './pages/Jobs';
import Survey, { SurveyResults } from './pages/Survey';
import Reports from './pages/Reports';
import WindowContextProvider from '../common/components/WindowContextProvider';
import News from './pages/News';
import Squads from './pages/Squads';
import GroupCandidates from './pages/GroupCandidates';

function PeopleApp(props) {
  return (
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <WindowContextProvider
        activeUser={props.activeUser}
        groups={props.groups}
        csrfToken={props.csrfToken}
      >
        <Router>
          <SentryRoutes>
            <Route path="/news/:id" element={<News {...props} />} />

            <Route path="/feedback/:topic" element={<FeedbackTopicPage {...props} />} />

            <Route path="/roles/:roleId" element={<RolePage {...props} />} />

            <Route path="/roles" element={<ProgressionPage {...props} />} />

            <Route path="/recruitment/*" element={<RecruitmentCandidates {...props} />} />

            <Route path="/candidates-admin" element={<CandidatesAdminList {...props} />} />

            <Route path="/users/:userId/checklist" element={<UserChecklist {...props} />} />

            <Route path="/users/health-and-safety" element={<HealthAndSafetyPage {...props} />} />

            <Route path="/users/:userId/*" element={<UserProfilePage {...props} />} />

            <Route path="/users" element={<UsersPage {...props} />} />

            <Route path="/team-time" element={<TeamTime {...props} />} />

            <Route path="/complete-timesheet" element={<CompleteTimesheet {...props} />} />

            <Route path="/admin/new-starters" element={<NewStartersPage {...props} />} />

            <Route path="/admin/jobs/*" element={<Jobs {...props} />} />

            <Route path="/skills" element={<PeopleLayout {...props} content={<Skills {...props} />} />} />

            <Route path="/group-candidates" element={<PeopleLayout {...props} title={props.group?.name} content={<GroupCandidates {...props} />} />} />

            <Route path="/survey/results" element={<SurveyResults {...props} />} />

            <Route path="/survey/*" element={<Survey />} />

            <Route path="/reports/*" element={<PeopleLayout {...props} title="Reports" content={<Reports />} />} />

            <Route path="/remote-working" element={<RemoteWorkingForm {...props} />} />

            <Route path="/shoutouts" element={<ShoutoutsPage {...props} />} />

            <Route path="/squads/*" element={<BasicPeopleLayout {...props}><Squads /></BasicPeopleLayout>} />

            <Route path="/" element={<Dashboard {...props} />} />
          </SentryRoutes>
        </Router>
      </WindowContextProvider>
    </Sentry.ErrorBoundary>
  );
}

export default Sentry.withProfiler(PeopleApp);
